/**
 * @desc 仓库SKU在途库存分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.inPlanMaster.transitListPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/inPlanMaster/transit/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
